import {createAsyncThunk, createSlice, current} from "@reduxjs/toolkit";
import {
    extendMultiPassBatchAPI,
    deleteMultiPassAPI,
    extendMultiPassAPI,
    getAllMultiPassAPI,
    insertMultiPassAPI,
    updateMultiPassAPI
} from "../../api/multiPass";
import moment from "moment/moment";
import {parsePaginationParams} from "../../utils/other";

export const fetchAllMultiPass = createAsyncThunk('fetchAllMultiPass', async (payload) => {
    const {filter, params} = payload;
    let validFrom = filter.validFrom ? filter.validFrom : null;
    let validTo = filter.validTo ? filter.validTo : null;
    if (validFrom) {
        validFrom = moment(validFrom).format("DD.MM.YYYY")
    }
    if (validTo) {
        validTo = moment(validTo).format("DD.MM.YYYY")
    }
    const parsedParams = parsePaginationParams(params)
    return await getAllMultiPassAPI({
        ...filter,
        validFrom,
        validTo
    }, parsedParams)
})

export const insertMultiPass = createAsyncThunk('insertMultiPass', async (data, {rejectWithValue}) => {
    try {
        return await insertMultiPassAPI(data);
    } catch (error) {
        return rejectWithValue(error?.response?.data || "serverErrorOccurred");
    }
})


export const extendMultiPass = createAsyncThunk('extendMultiPass', async (data) => {
    return await extendMultiPassAPI(data)
})

export const deleteMultiPass = createAsyncThunk('deleteMultiPass', async (cardName, {rejectWithValue}) => {
    try {
        const response = await deleteMultiPassAPI(cardName);
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        }
        return rejectWithValue(response.data);
    } catch (error) {
        if (error.data) {
            return rejectWithValue(error.data);
        }
        return rejectWithValue("serverErrorOccurred");
    }
})


export const updateMultiPass = createAsyncThunk('updateMultiPass', async (data, {rejectWithValue}) => {
    try {
        const response = await updateMultiPassAPI(data);
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        }
        return rejectWithValue(response.data);
    } catch (error) {
        return rejectWithValue(error?.response?.data || "serverErrorOccurred");
    }
})

export const extendMultiPassBatch = createAsyncThunk('extendMultiPassBatch', async (data, { rejectWithValue }) => {
    try {
        const response = await extendMultiPassBatchAPI(data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error?.response?.data || "serverErrorOccurred");
    }
});


const initialState = {
    foundMultiPass: [],
    loadingMultiPass: false,
}

export const MultiPassSlice = createSlice({
    name: 'multiPass',
    initialState,

    reducers: {
        specialLoading: (state, {payload}) => {
            if (payload) {
                state.loadingMultiPass = payload;
            }
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchAllMultiPass.pending, (state) => {
                state.loadingMultiPass = true;
            })
            .addCase(fetchAllMultiPass.fulfilled, (state, {payload}) => {
                state.foundMultiPass = payload.data;
                state.loadingMultiPass = false;
            })
            .addCase(fetchAllMultiPass.rejected, (state) => {
                state.loadingMultiPass = false;
            })
            .addCase(insertMultiPass.pending, (state) => {
                state.loadingMultiPass = true;
            })
            .addCase(insertMultiPass.fulfilled, (state) => {
                state.loadingMultiPass = false;
            })
            .addCase(insertMultiPass.rejected, (state) => {
                state.loadingMultiPass = false;
            })
            .addCase(deleteMultiPass.fulfilled, (state, {meta}) => {
                let content = state.foundMultiPass.content;
                if (Array.isArray(content)) {
                    const index = content.findIndex(rfd => rfd.id === meta.arg);
                    if (index !== -1) {
                        content.splice(index, 1);
                    }
                } else {
                    console.error('Content is not an array:', content);
                }
            })
            .addCase(updateMultiPass.fulfilled, (state, {payload}) => {
                // console.log(payload ,"PAPAPA")
                // let content = state.foundMultiPass.content;
                // if (Array.isArray(content)) {
                //     const index = content.findIndex(rfd => rfd.cardNumber === payload.cardNumber);
                //     console.log(index ,"index")
                //
                //     if (index !== -1) {
                //         content[index] = payload.data;
                //     }
                // } else {
                //     console.error('Content is not an array:', content);
                // }
            })
            .addCase(extendMultiPass.pending, (state) => {
                state.loadingMultiPass = true;
            })
            .addCase(extendMultiPass.fulfilled, (state, {payload}) => {
                const currentState = current(state.foundMultiPass);
                let arr = [...currentState.content];
                if (payload.data.cardNumber) {
                    let index = arr.findIndex((i) => i.cardNumber === payload.data.cardNumber);
                    if (index !== -1) {
                        arr[index] = payload.data;
                        state.foundMultiPass = {
                            ...currentState,
                            content: arr,
                        };
                    }
                }
                state.loadingMultiPass = false;
            })
            .addCase(extendMultiPass.rejected, (state) => {
                state.loadingMultiPass = false;
            });
    },
});

export const {specialLoading} = MultiPassSlice.actions;

export const MultiPassReducer = MultiPassSlice.reducer;


